import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Icon } from "../Icon";
import { useAuth } from "../auth";
import { PageHero, useSeo } from "../ui";

export default function VerifyEmail() {
  useSeo({ title: "이메일 인증 | I.META", path: "/verify", noindex: true });

  const [params] = useSearchParams();
  const token = params.get("token");
  const { call, refresh } = useAuth();
  const [state, setState] = useState("working"); // working | ok | fail
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;   // StrictMode 의 이중 실행으로 토큰을 두 번 쓰지 않게 한다
    ran.current = true;

    if (!token) { setState("fail"); setError("인증 링크가 올바르지 않습니다."); return; }
    (async () => {
      try {
        await call("/verify", { method: "POST", body: JSON.stringify({ token }) });
        await refresh();
        setState("ok");
      } catch (err) {
        setError(err.message);
        setState("fail");
      }
    })();
  }, [token, call, refresh]);

  const title = state === "working" ? "인증 중…" : state === "ok" ? "이메일 인증이 완료되었습니다" : "인증하지 못했습니다";
  const desc = state === "working" ? "잠시만 기다려주세요." : state === "ok" ? "이제 회원 기능을 모두 이용하실 수 있습니다." : error;

  return (
    <PageHero kicker="VERIFY" title={title} desc={desc}>
      {state !== "working" && (
        <div className="hero__actions">
          <Link to="/" className="btn btn--primary">
            홈으로 <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />
          </Link>
          <Link to="/account" className="btn btn--ghost">내 정보</Link>
        </div>
      )}
    </PageHero>
  );
}
